import Image from 'next/image';
import styled from 'styled-components';

import RouterLink from '../RouterLink';

export const Wrapper = styled.div`
  width: 100%;

  & a {
    text-decoration: none;
  }
`;

export const FooterContent = styled.div`
  background-color: ${({ theme }) => theme.palette.darkGrey};
  padding: 26px 0;
`;

export const FooterSocialMedia = styled.div`
  background: ${({ theme }) => theme.palette.white};
`;
export const FooterSocialMediaContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;

export const SocialMediaIconWrapper = styled.div`
  margin-right: 15px;
  display: inline-block;
  width: 50px;
  height: 50px;
  position: relative;
  img {
    cursor: pointer;
  }
`;

export const SocialMediaButtonWrapper = styled.div`
  margin-right: 20px;
  display: inline-flex;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
`;

export const SocialMediaBoxNumberWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  & > a {
    text-decoration: none !important;
  }
`;

export const SocialMediaBox = styled.div<{ greenBox?: boolean }>`
  display: flex;
  width: fit-content;
  padding: 12px 25px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.gray34};
  margin-left: 20px;
  align-items: center;
  cursor: pointer;
  color: ${({ theme, greenBox }) =>
    greenBox ? theme.palette.green : theme.palette.white};
`;
export const SocialMediaBoxText = styled.div`
  margin-left: 11px;
`;
export const BoxText = styled.div`
  display: flex;
  align-items: center;
  margin-left: 11px;
  & > a {
    text-decoration: none !important;
  }
`;
export const SocialMediaBoxLabel = styled.span`
  display: block;
  font-size: 14px;
`;
export const BoxLabel = styled.span`
  color: ${({ theme }) => theme.palette.white};
  display: block;
  font-size: 20px;
  font-weight: bold;
`;
export const SocialMediaBoxPhoneNumber = styled.span`
  font-size: 16px;
  font-weight: bold;
`;

export const FooterLogo = styled.div`
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: -10px;
  width: 153px;
  height: 28px;
  position: relative;
`;
export const FooterWrapper = styled.div`
  cursor: pointer;
  margin-bottom: 18px;
  margin-top: -20px;
  width: auto;
  height: 41px;
`;

export const FooterListsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
`;
export const FooterListsItem = styled.div`
  a {
    text-decoration: none !important;
  }
`;
export const FooterListsItemTitle = styled.span`
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
  height: 100%;
  color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: end;
`;

export const FooterListsItemLink = styled.span`
  font-size: 14px;
  line-height: 1.71;
  color: ${({ theme }) => theme.palette.white};
  display: block;
  margin-bottom: 10px;
`;
export const FooterListsSumItem = styled(RouterLink)`
  display: flex;
  margin-top: 20px;
`;

export const FooterListsSumItemLink = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  margin-right: 5px;
`;
export const FooterAboutCompany = styled.div`
  & > a {
    text-decoration: none !important;
  }
`;
export const FooterSeturLogosItems = styled.div`
  display: grid;
  grid-template-columns: 129px 84px 93px 117px 61px 50px 122px;
  grid-template-rows: 20px;
  justify-content: center;
  gap: 36px;
  margin-top: 70px;
  margin-bottom: 55px;
`;
export const FooterSeturLogosItem = styled.div<{
  footerWidth?: string;
  footerHeight?: string;
}>`
  cursor: pointer;
  position: relative !important;
  height: ${({ footerHeight }) => (footerHeight ? footerHeight : '100%')}px;
  width: ${({ footerWidth }) => footerWidth}px;
`;
export const FooterSeturLogosImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const FooterLineDivider = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  height: 1px;
  width: 57%;
  margin: 0 auto 30px auto;
`;

export const FooterTextWrapper = styled.div`
  margin-bottom: 50px;
`;

export const FooterItem = styled.div`
  margin: 0 auto 25px auto;
`;

export const FooterTextItem = styled.div<{ maxWidth?: number }>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};
  text-align: center;
  font-size: 14px;
  line-height: 1.71;
  margin: 0 auto;
  color: ${({ theme }) => theme.palette.white};
`;

export const FooterMetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;
export const FooterMetaHistory = styled.div`
  display: flex;
  align-items: center;
`;
export const FooterMetaHistoryYears = styled.span`
  font-size: 14px;
  line-height: 1.71;
  color: ${({ theme }) => theme.palette.white};
  margin-left: 20px;
  display: block;
  & > a {
    text-decoration: none !important;
  }
`;
export const TermsOfUse = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
`;
export const FooterMetaExtra = styled.div`
  display: flex;
  align-items: center;
`;
export const FooterMetaExtraLabel = styled.span`
  font-size: 14px;
  line-height: 1.71;
  color: ${({ theme }) => theme.palette.white};
  margin-right: 10px;
  display: block;
  text-align: end;
`;

export const FooterMetaEtbisInfo = styled.div``;
export const FooterMetaEtbis = styled.div``;
export const MobileEtbisInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FooterMetaExtraItem = styled.div`
  margin-right: 10px;
`;

export const VisaLogoWrapper = styled.div`
  width: 88.7px;
  height: 31px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const imgStyle = {
  height: 120,
  width: 100,
};

export const imgStyleMobile = {
  height: 115,
  width: 100,
};
